<template>
  <div class="tw:flex tw:flex-col tw:gap-2">
    <div class="tw:w-full tw:relative tw:h-2 tw:rounded-full tw:bg-gray-200">
      <div
        class="tw:absolute tw:h-2 tw:rounded-full"
        :style="{
          width: percentage + '%',
          background: props.color
        }"
      ></div>

      <div
        class="tw:absolute tw:w-4 tw:h-4 tw:rounded-full tw:top-1/2 tw:-translate-y-1/2 tw:-translate-x-1/2 tw:pointer-events-none tw:border-2 tw:border-white tw:shadow-sm"
        :style="{
          left: percentage + '%',
          background: props.color
        }"
      />

      <input
        type="range"
        class="tw:absolute tw:w-full tw:h-2 tw:opacity-0 tw:cursor-pointer"
        :min="props.min"
        :max="props.max"
        :step="props.step"
        :value="props.modelValue"
        @input="updateValue"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { watch, ref } from "vue"

interface Props {
  modelValue?: number |string
  min?: number |string
  max?: number |string
  step?: number |string
  showValue?: boolean
  color?: string
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: undefined,
  min: 0,
  max: 100,
  step: 1,
  showValue: true,
  color: "var(--maincolor)",
})

const emit = defineEmits<{
  (e: "update:modelValue", value: number): void,
  (e: "change", value: number): void
}>()

const percentage = ref(0)

function updateValue(event: Event) {
  const value = Number((event.target as HTMLInputElement).value)
  emit("update:modelValue", value)
  emit("change", value)
}

watch(
  () => props.modelValue,
  (newValue) => {
    if (newValue !== undefined) {
      percentage.value = ((Number(newValue) - Number(props.min)) / (Number(props.max) - Number(props.min))) * 100
    }
  },
  { immediate: true }
)
</script>
